import IconInfoCircleOutline from '@picsart/icons/IconInfoCircleOutline';
import classNames from 'classnames';
import { Tooltip } from '@quicktools/shared-components/components/core/Tooltip';

import { ReactComponent as RequiredStarIcon } from '../../../svgIcons/required-star.svg';

import { ITextLabel } from './types';
import useStyles from './styles';

function TextLabel({
  label,
  required,
  infoText,
  htmlFor,
  className,
  tooltipClassName,
  arrowClassName,
}: ITextLabel) {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className)}>
      <label className={classes.label} htmlFor={htmlFor}>
        {label}
      </label>
      {required && (
        <div className={classes.requiredStar}>
          <RequiredStarIcon />
        </div>
      )}
      {infoText && (
        <div className={classes.info}>
          <IconInfoCircleOutline />
          <Tooltip
            trigger="click"
            className={classNames(classes.toolTip, tooltipClassName)}
            arrowClassName={arrowClassName}
          >
            {infoText}
          </Tooltip>
        </div>
      )}
    </div>
  );
}
export default TextLabel;
